import { render, staticRenderFns } from "./Stt.vue?vue&type=template&id=27f4e810&scoped=true&lang=html&"
import script from "./Stt.vue?vue&type=script&lang=js&"
export * from "./Stt.vue?vue&type=script&lang=js&"
import style0 from "./Stt.vue?vue&type=style&index=0&id=27f4e810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4e810",
  null
  
)

export default component.exports